export default {"src":"/_next/static/media/support.42e19d10.svg","height":58,"width":57};